import { http } from '@/http'

// Variantes de plantilla de contrato personalizadas por colaborador (DOCX específico por colaborador+plantilla).
export default {
  list(employeeId) {
    return http.get(`/employees/${employeeId}/template-variants`)
  },
  createOrReplace(employeeId, { templateId, file, notes }) {
    const fd = new FormData()
    fd.append('templateId', templateId)
    fd.append('file', file)
    if (notes !== null && notes !== undefined) fd.append('notes', notes)
    return http.post(`/employees/${employeeId}/template-variants`, fd, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
  },
  remove(employeeId, variantId) {
    return http.delete(`/employees/${employeeId}/template-variants/${variantId}`)
  },
  download(employeeId, variantId) {
    return http.get(`/employees/${employeeId}/template-variants/${variantId}/download`, { responseType: 'blob' })
  },
}
